import { tableConstantsFactory } from './tableConstantsFactory';
const reportConstants = tableConstantsFactory('REPORT');

// add in extra constants here.
reportConstants.NOOP = 'NOOP';
reportConstants.FORMAT_EDIT = 'REPORT_FORMAT_EDIT';
reportConstants.FORMAT_DONE_EDIT = 'REPORT_FORMAT_DONE_EDIT';
reportConstants.FORMAT_CHANGE = 'REPORT_FORMAT_CHANGE';
reportConstants.FORMAT_SAVE = 'REPORT_FORMAT_SAVE';
reportConstants.RENDER = 'REPORT_RENDER';
reportConstants.RENDER_SUCCESS = 'REPORT_RENDER_SUCCESS';
reportConstants.RENDER_FAILURE = 'REPORT_RENDER_FAILURE';
reportConstants.FORMAT_SAVE_SUCCESS = 'REPORT_FORMAT_SAVE_SUCCESS';
reportConstants.FORMAT_SAVE_FAILURE = 'REPORT_FORMAT_SAVE_FAILURE';
export default reportConstants;